import { IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-corpactions-caadmin-v1-payment-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcCorpactionsCaadminV1PaymentStatus } from '@interxfi/types';
import { getEntityVariant } from '../../../../util/entity-status-variants';

interface CorpactCaAdminPaymentStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcCorpactionsCaadminV1PaymentStatus | undefined;
}

export function CorpactCaAdminPaymentStatusPill({ isPending, status, ...props }: CorpactCaAdminPaymentStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_CORPACTIONS_CAADMIN_V1_PAYMENT_STATE_ENTITY_NAME, status)}>
      <TranslatedText
        defaultValue={status}
        i18nKey={{ namespace: 'ixcCorpactionsCaadminV1', enumName: 'IxcCorpactionsCaadminV1PaymentStatus', value: status }}
      />
    </Pill>
  );
}
